export default "__VITE_ASSET__ec2e6cac__"